import React, { useMemo } from "react";
import { useRootElement } from "../context";
import * as styles from "./styles";
import { Text } from "~/components/deprecated/components/Text";

export const BarChart = () => {
  const { title, labels, data, unit } = useRootElement();

  const maxUnit = useMemo(() => {
    if (!data) return undefined;

    return [...data].sort((a, b) => a - b).reverse()[0];
  }, [data]);

  const chartUnit = useMemo(() => {
    if (!unit || !maxUnit) {
      return 100;
    }

    return Math.ceil(maxUnit / 10) * 10;
  }, [maxUnit, unit]);

  const barList = useMemo(
    () =>
      data.map((value, index) => ({
        label: labels[index],
        value,
        width: Math.round((value * 100) / chartUnit),
      })),
    [chartUnit, data, labels],
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Text variant="p" noMargin weight="--ll-font-weight-bold">
          {`${title} (${unit})`}
        </Text>
      </div>

      <div className={styles.body}>
        {barList.map((line) => (
          <div key={line.label} className={styles.row}>
            {line.label !== "0" && (
              <Text noMargin variant="caption2">
                {line.label}
              </Text>
            )}
            <div className={styles.bar}>
              <div
                className={styles.textContainer}
                style={{
                  left: `${line.width}%`,
                }}
              >
                <Text
                  noMargin
                  align="center"
                  color="--ll-color-on-background"
                  variant="caption2"
                >
                  {line.value}
                  {unit}
                </Text>
              </div>
              <span
                className={styles.amount}
                style={{
                  width: `${line.width}%`,
                }}
              />
            </div>
          </div>
        ))}
      </div>

      <div className={styles.footer}>
        <Text noMargin variant="caption2" color="--ll-color-on-background">
          0
        </Text>
        <Text
          noMargin
          variant="caption2"
          align="center"
          color="--ll-color-on-background"
        >
          {`${chartUnit / 2}${unit}`}
        </Text>
        <Text
          noMargin
          variant="caption2"
          align="right"
          color="--ll-color-on-background"
        >
          {`${chartUnit}${unit}`}
        </Text>
      </div>
    </div>
  );
};
